import { render, staticRenderFns } from "./VisaProDes.vue?vue&type=template&id=23a52806&scoped=true"
import script from "./VisaProDes.vue?vue&type=script&lang=js"
export * from "./VisaProDes.vue?vue&type=script&lang=js"
import style0 from "./VisaProDes.vue?vue&type=style&index=0&id=23a52806&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a52806",
  null
  
)

export default component.exports